import { MATRIX_MAX_COLUMNS } from '../../matrix/MatrixHelper';
import Matrix from '../../matrix/Matrix';

const dataSource = {
    url: '/query/matrix',
    params: {
        type: 'businessservice,site',
        columnLimit: MATRIX_MAX_COLUMNS,
        entityFields: 'name,tags',
        metrics: 'status,bsSiteCounts,bsStatusDevices,bsStatusServers,bsTestExperience',
        noParent: true,
        pivot: 'bsSiteCounts',
        renderAsEntity: true,
        sort: '-bsSiteCounts,-bsSiteCounts',
    },
    totalProperty: 'rowCount',
};

export default function BusinessServicesOverviewMatrix(props) {
    return <Matrix {...props} dataSource={dataSource} />;
}
